export const lineBreaksRegExp = /(?:\r\n|\r|\n)/g;

export default (string = '') => string.replace(lineBreaksRegExp, '');
